import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_12jikkq1: FaireBrandEntity = {
  token: "b_12jikkq1",
  type: "brand",
  name: "Routine Natural Beauty",
  avatarUrl:
    "https://cdn.faire.com/fastly/2ddc7bba736a95698e347e9a21e0aeb4dc9f339b5f0c97e840b9e76cc4764b9a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3a3715961111d91a0b36eeb20722cb011bf45e4bd04440a60fdb837e1a1a22ea.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2ddc7bba736a95698e347e9a21e0aeb4dc9f339b5f0c97e840b9e76cc4764b9a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3a3715961111d91a0b36eeb20722cb011bf45e4bd04440a60fdb837e1a1a22ea.jpeg",
  location: "Calgary, AB, CAN",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 153,
  isTopShop: true,
  isInsider: false,
  description:
    "PLEASE BE ADVISED: EXTREME DELAYS AT USA BORDER ON ALL USA BOUND ORDERS!\n\nAt Routine, we believe that your scent is like a fingerprint, and how you choose to smell tells a story. Our credo is to offer beautiful, natural personal products, made wild in the West, that feel and smell incredible. Everyday routines that do good and are life-changing. To compliment your pheromones without compromise. To honour nature. To produce kinder to the earth, mindfully sourced packaging and products in our neighbourhood home of Canadian Rockies. To fall in love with how YOU smell.\n\nAnd most honestly, to bring to the joy, fun and wild back into the modern bathroom.\n\n\n\nGiddyup!\n\nXo,\n\nN & P",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:53.012Z",
    importedBy: "entity-db-cli",
  },
};
